import { Activity, ActivityType } from '@apeiron/common'
import { NextImage } from '@apeiron/temp'
import { ApeironTooltip } from '@apeiron/ui'
import { styled } from '@mui/material'
import BountyPNG from '@public/icons/icon-bounty.png'
import EmporiumPNG from '@public/icons/icon-emporium.png'
import { FC, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

const ActivityTypeIcon = styled(NextImage)`
  width: 24px;
  aspect-ratio: 1;
  min-width: 24px;
`

const ApostleActivityItem: FC<Props> = props => {
  const { activity, className } = props

  const { t } = useTranslation()

  const hoverId = `${activity.type}_${activity.transaction.hash}`

  const activityIcon = useMemo(() => {
    if (activity.type === ActivityType.ApostleBounty) {
      return BountyPNG
    } else {
      return EmporiumPNG
    }
  }, [activity.type])

  const activityVia = useMemo(() => {
    if (activity.type === ActivityType.ApostleBounty) {
      return t('apostle.activities.via_bounty')
    } else {
      return t('apostle.activities.via_emporium')
    }
  }, [activity.type, t])

  return (
    <>
      <ApeironTooltip id={hoverId}>{activityVia}</ApeironTooltip>
      <ActivityTypeIcon
        className={className}
        data-tooltip-id={hoverId}
        src={activityIcon}
      />
    </>
  )
}

type Props = {
  className?: string
  activity: Activity
}

export default ApostleActivityItem
